<template>
  <ItemBox id="item-n-3" :visible="visible" title="Innovation Capability Index 1" :headerItems="headerItems"
    toggleClass="item3-toggle minus" :closeAction="closeItem" :graphViewClick="graphViewClick"
    :graphToggle="graphToggle">

    <!--  -->
    <template v-if="graphToggle">
      <div class="pt-4 col-span-12">
        <div class="featured grid col-span-12 flex flex-col gap-2 px-3">
          <div class="f-data grid grid-cols-12 gap-2">

            <div class="ici1ValueContainer grid grid-cols-10 col-span-10 h-96 overflow-y-auto gap-2">

              <!-- Enabler 1 -->
              <div class="col-span-10 grid grid-cols-10 gap-2 m-2">

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C1</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.nc_RELATIONSHIPS }}
                    </h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.nc_RELATIONSHIPS, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.nc_RELATIONSHIPS)"></div>
                </div>

                <div class="flex col-span-1 row-span-5 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">1</h4>
                  </div>
                </div>

                <div class="flex col-span-1 row-span-5 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <div class="flex rating border-2 py-1 px-1.5 pb-1.5  rounded-lg leading-3 justify-center"
                      :class="getColorClass(this.questionnaireResults.nc_CHARACTERISTICS, 'border')">
                      {{ this.questionnaireResults.nc_CHARACTERISTICS }}
                    </div>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C2</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.nc_PERFORMANCE }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.nc_PERFORMANCE, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.nc_PERFORMANCE)"></div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C3</h4>
                  </div>
                </div>
                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.nc_PROCESS }}</h4>
                  </div>
                </div>
                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.nc_PROCESS, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.nc_PROCESS)"></div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C4</h4>
                  </div>
                </div>
                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.nc_KNOWLEDGE }}</h4>
                  </div>
                </div>
                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full">
                    <div class="resultProgressBar rounded-full h-full barTransition"
                      :class="getColorClass(this.questionnaireResults.nc_KNOWLEDGE, 'bg')"
                      :style="calculateBorder(this.questionnaireResults.nc_KNOWLEDGE)"></div>
                  </div>
                </div>
                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C5</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.nc_CONNECT }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full">
                    <div class="resultProgressBar rounded-full h-full barTransition"
                      :class="getColorClass(this.questionnaireResults.nc_CONNECT, 'bg')"
                      :style="calculateBorder(this.questionnaireResults.nc_CONNECT)"></div>
                  </div>
                </div>

              </div>

              <!-- Enabler 2 -->
              <div class="col-span-10 grid grid-cols-10 gap-2 m-1">

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C6</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.og_EMPOWERMENT }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#f3f4f8] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.og_EMPOWERMENT, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.og_EMPOWERMENT)"></div>
                </div>

                <div class="flex col-span-1 row-span-3 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">2</h4>
                  </div>
                </div>

                <div class="flex col-span-1 row-span-3 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <div
                      class="flex border rating border-2 py-1 px-1.5 pb-1.5 border-[#d4d4d4] rounded-lg leading-3 justify-center"
                      :class="getColorClass(this.questionnaireResults.nc_ORGANIZATIONAL_GOVERNANCE, 'border')">
                      {{ this.questionnaireResults.nc_ORGANIZATIONAL_GOVERNANCE }}
                    </div>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C7</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.og_PERFORMANCE }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#f3f4f8] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.og_PERFORMANCE, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.og_PERFORMANCE)"></div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C8</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.og_BUGETING }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#f3f4f8] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.og_BUGETING, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.og_BUGETING)"></div>
                </div>

              </div>

              <!-- ^3 -->
              <div class="col-span-10 grid grid-cols-10 gap-2 m-1">

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C9</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.oa_PROCESS }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.oa_PROCESS, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.oa_PROCESS)"></div>
                </div>

                <div class="flex col-span-1 row-span-3 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">3</h4>
                  </div>
                </div>

                <div class="flex col-span-1 row-span-3 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <div
                      class="flex border rating border-2 py-1 px-1.5 pb-1.5 border-[#d4d4d4] rounded-lg leading-3 justify-center"
                      :class="getColorClass(this.questionnaireResults.nc_ORGANIZATIONAL_ARCHITECTURE, 'border')">
                      {{ this.questionnaireResults.nc_ORGANIZATIONAL_ARCHITECTURE }}
                    </div>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C10</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.oa_MODULARITY }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.oa_MODULARITY, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.oa_MODULARITY)"></div>
                </div>
                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C11</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.oa_CUSTOMIZATION }}
                    </h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.oa_CUSTOMIZATION, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.oa_CUSTOMIZATION)"></div>
                </div>

              </div>

              <!-- Enabler 4 -->
              <div class="col-span-10 grid grid-cols-10 gap-2 m-1">

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C12</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.ti_CONNECTIVITY }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#f3f4f8] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.ti_CONNECTIVITY, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.ti_CONNECTIVITY)"></div>
                </div>

                <div class="flex col-span-1 row-span-5 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">4</h4>
                  </div>
                </div>

                <div class="flex col-span-1 row-span-5 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <div
                      class="flex border rating border-2 py-1 px-1.5 pb-1.5 border-[#d4d4d4] rounded-lg leading-3 justify-center"
                      :class="getColorClass(this.questionnaireResults.nc_TECHNICALIT_INFRASTRUCTURE, 'border')">
                      {{ this.questionnaireResults.nc_TECHNICALIT_INFRASTRUCTURE }}
                    </div>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C13</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.ti_COMPATIBILITY }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#f3f4f8] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.ti_COMPATIBILITY, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.ti_COMPATIBILITY)"></div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C14</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.ti_MODULARITY }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#f3f4f8] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.ti_MODULARITY, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.ti_MODULARITY)"></div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C15</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.ti_REUSABILITY }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#f3f4f8] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.ti_REUSABILITY, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.ti_REUSABILITY)"></div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C16</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.ti_DATASHARING }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#f3f4f8] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.ti_DATASHARING, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.ti_DATASHARING)"></div>
                </div>

              </div>

              <!-- Enabler 5 -->
              <div class="col-span-10 grid grid-cols-10 gap-2 m-1">

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C17</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.hi_TECHNOLOGY }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.hi_TECHNOLOGY, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.hi_TECHNOLOGY)"></div>
                </div>

                <div class="flex col-span-1 row-span-3 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">5</h4>
                  </div>
                </div>

                <div class="flex col-span-1 row-span-3 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <div
                      class="flex border rating border-2 py-1 px-1.5 pb-1.5 border-[#d4d4d4] rounded-lg leading-3 justify-center"
                      :class="getColorClass(this.questionnaireResults.hi_HUMANIT_INFRASTRUCTURE, 'border')">
                      {{ this.questionnaireResults.hi_HUMANIT_INFRASTRUCTURE }}
                    </div>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C18</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.hi_MANAGEMENT_SKILLS }}
                    </h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.hi_MANAGEMENT_SKILLS, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.hi_MANAGEMENT_SKILLS)"></div>
                </div>
                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C19</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.hi_TECHNICAL_SKILLS }}
                    </h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.hi_TECHNICAL_SKILLS, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.hi_TECHNICAL_SKILLS)"></div>
                </div>

              </div>

              <!-- Enabler 6 -->
              <div class="col-span-10 grid grid-cols-10 gap-2 m-1">

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C20</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.oc_LEADERSHIP }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#f3f4f8] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.oc_LEADERSHIP, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.oc_LEADERSHIP)"></div>
                </div>

                <div class="flex col-span-1 row-span-3 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">6</h4>
                  </div>
                </div>

                <div class="flex col-span-1 row-span-3 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <div class="flex border rating border-2 py-1 px-1.5 pb-1.5 rounded-lg leading-3 justify-center"
                      :class="getColorClass(this.questionnaireResults.hi_ORGANIZATIONAL_CULTURE, 'border')">
                      {{ this.questionnaireResults.hi_ORGANIZATIONAL_CULTURE }}
                    </div>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C21</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.oc_FOSTERING }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#f3f4f8] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.oc_FOSTERING, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.oc_FOSTERING)"></div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C22</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#f3f4f8] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.oc_INTERACTIONS }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#f3f4f8] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.oc_INTERACTIONS, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.oc_INTERACTIONS)"></div>
                </div>

              </div>

              <!-- Enabler 7 -->
              <div class="col-span-10 grid grid-cols-10 gap-2 m-1">

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C23</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.hs_KNOWLEDGE }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.hs_KNOWLEDGE, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.hs_KNOWLEDGE)"></div>
                </div>

                <div class="flex col-span-1 row-span-2 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">7</h4>
                  </div>
                </div>

                <div class="flex col-span-1 row-span-2 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <div
                      class="flex border rating border-2 py-1 px-1.5 pb-1.5 border-[#d4d4d4] rounded-lg leading-3 justify-center"
                      :class="getColorClass(this.questionnaireResults.hi_HUMAN_KNOWLEDGE, 'border')">
                      {{ this.questionnaireResults.hi_HUMAN_KNOWLEDGE }}
                    </div>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="text-start leading-4">C24</h4>
                  </div>
                </div>

                <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-between">
                  <div class="flex justify-center w-full">
                    <h4 class="resultNumValue text-start leading-4">{{ this.questionnaireResults.hs_SPEED_ACQ }}</h4>
                  </div>
                </div>

                <div class="flex flex-col h-full bg-[#fbfaff] rounded-full col-span-6 gap-2">
                  <div class="resultProgressBar rounded-full h-full barTransition"
                    :class="getColorClass(this.questionnaireResults.hs_SPEED_ACQ, 'bg')"
                    :style="calculateBorder(this.questionnaireResults.hs_SPEED_ACQ)"></div>
                </div>

              </div>


            </div>

            <div class="grid grid-cols-2 col-span-2 gap-2 mr-0.5 ml-2 pt-1 text-sm">

              <div class="flex col-span-1 bg-[#fbfaff] rounded-xl py-1 px-4 items-center justify-between">
                <div class="flex w-full justify-center">
                  <h4 class="text-center">Network Characteristics</h4>
                </div>
              </div>

              <div class="flex col-span-1 bg-[#fbfaff] rounded-xl p-1 items-center justify-center">
                <div class="flex justify-center">
                  <div
                    class="flex border rating border-2 px-4 py-5 border-[#82ca74] rounded-xl leading-4 w-full justify-center"
                    :class="getColorClass(this.questionnaireResults.nc_CHARACTERISTICS, 'border')">
                    {{ this.questionnaireResults.nc_CHARACTERISTICS }}
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </template>


    <div v-else class="featured grid col-span-12 flex flex-col gap-2">
      <div class="f-graph grid grid-cols-12 gap-2">

        <GraphIci :bgLines="true" :circles="dynamicCircles" :hoveredIndex="hoveredIndex" :setHoveredIndex="setHoveredIndex" :categories="categories" />


        <div class="flex flex-col col-span-2 pt-16 pr-12 font-semibold gap-4">
          <div class="flex items-center">
            <div class="shrink-0 grow-0 flex h-5 w-5 rounded-full border-2 border-black">
              <p class="invisible">helolo</p>
            </div>
            <p class="uppercase text-lg leading-5 text-start ml-4">Position of enabler if aligned</p>
          </div>
          
         
        </div>

        <div class="flex flex-col gap-2 col-span-4 py-4">

          <div class="flex justify-between border-2 border-[#aedddb] rounded-xl p-2 pl-3 w-full h-fit">
            <h4 class="leading-6">Category</h4>
            <div class="flex border-2 border-[#aedddb] rounded-lg p-1 leading-4">Mean</div>
          </div>

          <div v-for="(category, index) in categories" :key="index"
            class="flex justify-between rounded-xl p-2 pl-3 w-full h-fit  duration-150 ease-in-out"
            @mouseover="setHoveredIndex(index)" @mouseleave="setHoveredIndex(null)"
            :class="hoveredIndex === index ? 'bg-[#aedddb]' : 'bg-[#fbfaff]'">
            <h4 class="leading-6">{{ category.name }}</h4>
            <div class="flex border-2 rating rounded-lg p-1 leading-4" 
                 :class="[
                   getColorClass(category.mean, 'border'), 
                   { [getColorClass(category.mean, 'bg')]: hoveredIndex === index }
                 ]">
                {{ category.mean == '1' ? '1.00' : category.mean }}
              </div>
            </div>
          </div>

        </div>
      </div>
  </ItemBox>
</template>

<script>
import ItemBox from '@/components/results/ItemBox.vue'
import GraphCircles from '@/components/results/GraphCircles.vue'
import GraphIci from '@/components/results/GraphIci.vue'
import { getColorClass } from '@/utils/agilityRatings';


export default {
  components: {
    ItemBox, GraphCircles, GraphIci
  },
  data() {
    return {
      hoveredIndex: null,
      headerItems: [
        { name: 'Criterion #', class: 'col-span-1' },
        { name: 'Mean', class: 'col-span-1' },
        { name: 'Scale', class: 'col-span-6', scale: true },

        { name: 'Enabler #', class: 'col-span-1' },
        { name: 'Mean', class: 'col-span-1' },
        { name: 'Mean Alignment', class: 'col-span-1' },
        { name: 'IC1', class: 'col-span-1 ', color: 'border border-[#aedddb] bg-white' },
      ]
    }
  },
  computed: {
    dynamicCircles() {
      const maxOffset = 400; // Increased from 323.5 to give more space from center
      const centerX = 600;
      const centerY = 600;
      
      return this.categories.map((category, index) => {
        const score = parseFloat(category.mean);
        const normalizedScore = Math.max(0, Math.min(10, score)); // Clamp between 0-10
        
        // Position: 0 close to center, 10 at max distance
        const distance = (normalizedScore / 10) * maxOffset;
        
        // Rotation: evenly distribute around circle
        const rotation = (360 / this.categories.length) * index;
        
        // Color based on score using existing color system
        const colorClass = this.getColorClass(score, 'indicator');
        let fillColor = '#D4D4D4'; // default gray
        
        if (colorClass === 'green') fillColor = '#82CA74';
        else if (colorClass === 'yellow') fillColor = '#F8D25B';
        else if (colorClass === 'orange') fillColor = '#F4A14A';
        else if (colorClass === 'red') fillColor = '#F07620';
        
        // Size based on score
        const minRadius = 40; // Increased from 30
        const maxRadius = 100; // Increased from 90
        const radius = minRadius + ((maxRadius - minRadius) * (normalizedScore / 10));
        
        return {
          cx: centerX,
          cy: centerY,
          r: radius,
          fill: fillColor,
          rotation: rotation,
          translateY: -distance,
          strokeTranslateY: -distance * 0.7, // No longer used but kept for compatibility
          score: score
        };
      });
    },
    enablers() {
      return [
        {
          enabler: 1,
          mean: this.questionnaireResults.nc_CHARACTERISTICS,
          criterions: [{
            criterion: 'C1',
            mean: this.questionnaireResults.nc_RELATIONSHIPS
          },
          {
            criterion: 'C2',
            mean: this.questionnaireResults.nc_PERFORMANCE
          },
          {
            criterion: 'C3',
            mean: this.questionnaireResults.nc_PROCESS
          }, {
            criterion: 'C4',
            mean: this.questionnaireResults.nc_KNOWLEDGE
          },
          {
            criterion: 'C5',
            mean: this.questionnaireResults.nc_CONNECT
          },
          ]
        },
        {
          enabler: 2,
          mean: this.questionnaireResults.nc_ORGANIZATIONAL_GOVERNANCE,
          criterions: [{
            criterion: 'C6',
            mean: this.questionnaireResults.og_EMPOWERMENT
          },
          {
            criterion: 'C7',
            mean: this.questionnaireResults.nc_PERFORMANCE
          },
          {
            criterion: 'C8',
            mean: this.questionnaireResults.og_BUGETING
          }
          ]
        },
        {
          enabler: 3,
          mean: this.questionnaireResults.nc_ORGANIZATIONAL_ARCHITECTURE,
          criterions: [{
            criterion: 'C9',
            mean: this.questionnaireResults.oa_PROCESS
          },
          {
            criterion: 'C10',
            mean: this.questionnaireResults.oa_MODULARITY
          },
          {
            criterion: 'C11',
            mean: this.questionnaireResults.oa_CUSTOMIZATION
          }
          ]
        },
        {
          enabler: 4,
          mean: this.questionnaireResults.nc_TECHNICALIT_INFRASTRUCTURE,
          criterions: [{
            criterion: 'C12',
            mean: this.questionnaireResults.ti_CONNECTIVITY
          },
          {
            criterion: 'C13',
            mean: this.questionnaireResults.ti_COMPATIBILITY
          },
          {
            criterion: 'C14',
            mean: this.questionnaireResults.ti_MODULARITY
          },
          {
            criterion: 'C15',
            mean: this.questionnaireResults.ti_REUSABILITY
          },
          {
            criterion: 'C16',
            mean: this.questionnaireResults.ti_DATASHARING
          }
          ]
        },
        {
          enabler: 5,
          mean: this.questionnaireResults.hi_HUMANIT_INFRASTRUCTURE,
          criterions: [{
            criterion: 'C17',
            mean: this.questionnaireResults.hi_TECHNOLOGY
          },
          {
            criterion: 'C18',
            mean: this.questionnaireResults.hi_MANAGEMENT_SKILLS
          },
          {
            criterion: 'C19',
            mean: this.questionnaireResults.hi_TECHNICAL_SKILLS
          }
          ]
        },
        {
          enabler: 6,
          mean: this.questionnaireResults.hi_ORGANIZATIONAL_CULTURE,
          criterions: [{
            criterion: 'C20',
            mean: this.questionnaireResults.oc_LEADERSHIP
          },
          {
            criterion: 'C21',
            mean: this.questionnaireResults.oc_FOSTERING
          },
          {
            criterion: 'C22',
            mean: this.questionnaireResults.oc_INTERACTIONS
          }
          ]
        },
        {
          enabler: 7,
          mean: this.questionnaireResults.hi_HUMAN_KNOWLEDGE,
          criterions: [{
            criterion: 'C23',
            mean: this.questionnaireResults.hs_KNOWLEDGE
          },
          {
            criterion: 'C24',
            mean: this.questionnaireResults.hs_SPEED_ACQ
          },
          ]
        }
      ]
    },
    categories() {
      return [
        {
          name: 'Network Characteristics',
          mean: this.questionnaireResults.nc_CHARACTERISTICS
        },
        {
          name: 'Organisational Governance',
          mean: this.questionnaireResults.nc_ORGANIZATIONAL_GOVERNANCE
        },
        {
          name: 'Organisational Architecture',
          mean: this.questionnaireResults.nc_ORGANIZATIONAL_ARCHITECTURE
        },
        {
          name: 'Technical IT Infrastructure',
          mean: this.questionnaireResults.nc_TECHNICALIT_INFRASTRUCTURE
        },
        {
          name: 'Human IT Infrastructure',
          mean: this.questionnaireResults.hi_HUMANIT_INFRASTRUCTURE
        },
        {
          name: 'Organisational Culture',
          mean: this.questionnaireResults.hi_ORGANIZATIONAL_CULTURE
        },
        {
          name: 'Human Knowledge and Skills',
          mean: this.questionnaireResults.hi_HUMAN_KNOWLEDGE
        }
      ];
    }
  },
  props: {
    graphViewClick: {
      type: Boolean,
      required: false
    },
    graphToggle: {
      type: Boolean,
      required: false
    },
    calculateBorder: {
      type: Function,
      required: true
    },
    calculateColor: {
      type: Function,
      required: true
    },
    questionnaireResults: {
      type: Array,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    closeAction: {
      type: Function,
      required: true
    },
    getBgClass: {
      type: Function,
      required: true
    }
  },
  methods: {
    closeItem() {
      this.closeAction();
    },
    setHoveredIndex(index) {
      this.hoveredIndex = index;
    },
    getColorClass
  }
};
</script>

<style scoped>
/* Inner shadow using filter */
.shadow-inner {
  filter: drop-shadow(0 0 20px rgba(0, 0, 0, 0.5));
}
</style>